/** Return within the shop; direct/external arrivals use the collection link. */
class MabeProductBack extends HTMLElement {
  connectedCallback() { this.querySelector('a')?.addEventListener('click', this.onBack); }
  disconnectedCallback() { this.querySelector('a')?.removeEventListener('click', this.onBack); }
  onBack = (event) => {
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    try {
      const previous = new URL(document.referrer);
      if (previous.origin === location.origin && previous.href !== location.href && history.length > 1) {
        event.preventDefault();
        history.back();
      }
    } catch { /* An absent referrer uses the normal collection link. */ }
  };
}
if (!customElements.get('mabe-product-back')) customElements.define('mabe-product-back', MabeProductBack);
